module.exports = __webpack_public_path__ + "img/Z86Q_04.ab8fa8f5.jpg";